import isNumber from 'lodash/isNumber'

import { buildRiskProduct } from './formActions'

export const submitForm = async (state, formValues) => {
  const { formRiskProductType, riskProductId, crudActions } = state
  const newRiskProduct = buildRiskProduct(formValues, formRiskProductType)
  const isCreatingNewRiskProduct = creatingNewRiskProduct(state)

  if (isCreatingNewRiskProduct) {
    await crudActions.create(newRiskProduct)
  } else {
    await crudActions.update({ ...newRiskProduct, id: riskProductId })
  }
}

export const deleteRiskProduct = async (state) => {
  const { crudActions } = state

  await crudActions.delete(state.riskProduct.id)
}

const creatingNewRiskProduct = (state) =>
  !isNumber(state.riskProductIndex)
